import { useStoreState } from '@/stores/store';
import ConfirmModal from '../SharedComponents/ConfirmModal/ConfirmModal';
import { ProgressCharts } from '../CustomWebView/ProgressCharts';

export const StarsCharts = ({ isVisible, onConfirm }) => {
  const signedInUser = useStoreState((state) => state.signedInUser);

  return (
    <ConfirmModal
      isVisible={isVisible}
      confirmText={'weiter'}
      confirmAction={() => {
        onConfirm(false);
      }}
      hasWebView
    >
      <ProgressCharts patientId={signedInUser?.user?._id} />
    </ConfirmModal>
  );
};
